import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import axios from "axios";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, Pagination } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PageSpinner from "../PageSpinner";
import Banner from "../common/banner";
import CommonGrid from "../common/commongrid";
import renderInput from "../common/renderinput";
import appConfig from '../../config/config';
import PropertyReportLien from "./PropertyReportLien";

const colHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'Grantee', text: 'Plaintiff' },
    { dataField: 'Grantor', text: 'Defendant' },
    { dataField: 'Prior', text: 'UCC' },
    { dataField: 'DEEDDATE', text: 'Rec Date' },
    { dataField: 'RECDATE', text: 'Lien Amount' },
    { dataField: 'VOLINST', text: 'Docket-case' },
    { dataField: 'VOLINST', text: 'Docket Date' },
    { dataField: 'VOLINST', text: 'Vol-Inst' },
    { dataField: 'PAGE', text: 'Page' }
];
var orderColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });



class PropertyReportLienMain extends Component {


    //Add 

    constructor(...args) {
        super(...args);
        this.state = {
            addrow : false //,
            //showBanner: false, message: '', IsDataLoaded: false, OrderData: {}
        };
    }
    Add = ( toggle)=> {
       // this.loadNotes(); Load grid
        this.setState({ ...this.state, addrow:toggle });
    }

/*
    closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    submit = (values) => {
        axios.post(
            appConfig.apiGateway.updatePropertyReport,
            JSON.stringify({
                ...values, OrderId: this.props.OrderId,
                OrderProductId: this.props.OrderProductId,
                Action: "Lien",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => {
            if (response.data.Count > 0) {
                var myObject = JSON.parse(response.data.body);
                this.props.dispatch(reset('propertyReportLienForm'))
            }
        },
            (error) => {
                this.setState(state => ({ ...state, message: error, showBanner: true }));

            });

    }

    selectRow(Id) {
    } */
    render() {
        return (
            <>
                <CommonGrid data={[]} OrderColumns={orderColumns} setSelectedRow={this.selectRow} />
                <hr/>
                {this.state.addrow && <PropertyReportLien Add={this.Add}/>}
                {!this.state.addrow && 
                    <Button type="button" onClick={()=> this.Add(true)}>Add Lien</Button>}
            </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};

    return errors;
}
var propertyReportLienMainForm = reduxForm({
    form: 'propertyReportLienMainForm',
    validate
})(PropertyReportLienMain);

propertyReportLienMainForm = connect(
    state => ({
        session: state.session
    })
)(propertyReportLienMainForm);

export default propertyReportLienMainForm;